/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsDown = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m7 6 5 5 5-5" }],
    ["path", { d: "m7 13 5 5 5-5" }]
  ]
];

export { ChevronsDown as default };
//# sourceMappingURL=chevrons-down.js.map
